import axios from "axios";

class RecipeService {

    constructor() {
        this.remote = axios.create({
            baseURL: 'https://www.the-barkers.org/'
        });
        this.recipeCache = null;
    }

    recipes() {
        if (this.recipeCache) {
            return Promise.resolve(this.recipeCache);
        } else {
            return new Promise((resolve, reject) => {
                this.remote.get('/recipes')
                    .then(recipes => {
                        this.recipeCache = recipes.data;
                        resolve(recipes.data);
                    })
                    .catch(error => {
                        console.log(error);
                        reject(error);
                    });
            });
        }
    }

    recipe(id) {
        return new Promise((resolve, reject) => {
            this.remote.get('/recipes/' + id)
                .then(recipe => resolve(recipe.data))
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    ingredients() {
        return new Promise((resolve, reject) => {
            this.remote.get('/ingredients')
                .then(ingredients => resolve(ingredients.data))
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
}

const INSTANCE = new RecipeService();

export default INSTANCE;